import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3720fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { watch, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'XButton',
  props: {
    labelProp: {
        type: String,
    },
    srcProp: {
        type: String,
    }
},
  setup(__props) {

const props = __props



const label = ref(props.labelProp);
const src = ref(props.srcProp);

watch(() => props.labelProp, (newVal) => {
    if (newVal) {
        label.value = newVal;
    } else {
        label.value = '';
    }
});

watch(() => props.srcProp, (newVal) => {
    if (newVal) {
        src.value = newVal;
    } else {
        src.value = '';
    }
});


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, { class: "x1-button button-clear" }, {
    default: _withCtx(() => [
      (src.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "x1-button-before-icon",
            src: src.value
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(label.value), 1)
    ]),
    _: 1
  }))
}
}

})